module.exports = __webpack_public_path__ + "img/DE00729.13195752.png";